import { asyncActionType } from 'util/methods';

export const INSPECTION_JOB_INIT = 'INSPECTION_JOB_INIT';

//  ******* Fetch Related *******

export const INSPECTION_JOB_FETCH_BEGIN = 'INSPECTION_JOB_FETCH_BEGIN';
export const INSPECTION_JOB_FETCH_SUCCESS = 'INSPECTION_JOB_FETCH_SUCCESS';
export const INSPECTION_JOB_FETCH_FAIL = 'INSPECTION_JOB_FETCH_FAIL';

// ********** Inspection Form Submission Actions **************

export const INSPECTION_JOB_SUBMIT_BEGIN = 'INSPECTION_JOB_SUBMIT_BEGIN';
export const INSPECTION_JOB_SUBMIT_SUCCESS = 'INSPECTION_JOB_SUBMIT_SUCCESS';
export const INSPECTION_JOB_SUBMIT_FAIL = 'INSPECTION_JOB_SUBMIT_FAIL';
export const INSPECTION_JOB_UPLOAD_BEGIN = 'INSPECTION_JOB_UPLOAD_BEGIN';
export const INSPECTION_JOB_UPLOAD_SUCCESS = 'INSPECTION_JOB_UPLOAD_SUCCESS';

//  ******* Job Update PUT ********

export const INSPECTION_JOB_UPDATE_BEGIN = 'INSPECTION_JOB_UPDATE_BEGIN';
export const INSPECTION_JOB_UPDATE_SUCCESS = 'INSPECTION_JOB_UPDATE_SUCCESS';
export const INSPECTION_JOB_UPDATE_FAIL = 'INSPECTION_JOB_UPDATE_FAIL';

export const INSPECTION_JOB_RESET = 'INSPECTION_JOB_RESET';
export const INSPECTION_JOB_GET_LAB_LIST = asyncActionType('INSPECTION_JOB_GET_LAB_LIST');
